import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@uk-source-web/collapsible-container';
import Image from '@uk-source-web/image';
import {
  CrossSellingCards,
  CrossSellingContent,
  CrossSellingContentWrapper,
  CrossSellingImageWrapper,
} from './CrossSellingAccordionCard.styles';
import { Paragraph } from '@uk-source-web/paragraph';
import { Button } from '@uk-source-web/button';
import { Accordion } from '@uk-source-web/accordion';
import { Heading } from '@uk-source-web/heading';
import { CrossSellingAccordionCardProps } from './CrossSellingAccordionCard.types';
import usingOpcoUrl from '@/helpers/prefixHelper';
import { LinkWithIcon } from '@uk-source-web/link-with-icon';
import { getImage, getSrc } from 'gatsby-plugin-image';

const CrossSellingAccordionCard = ({ buttonText, dxlInformation, thumbnailIcon }: CrossSellingAccordionCardProps) => {
  const thumbnailIconSrc =
    typeof thumbnailIcon === 'string'
      ? thumbnailIcon
      : getSrc(thumbnailIcon) || getImage(thumbnailIcon)?.placeholder?.fallback || '';

  const price = dxlInformation?.price?.[0]?.price;
  const formattedPrice = typeof price === 'number' ? price.toFixed(2) : '-';

  return (
    <CrossSellingCards>
      <Accordion appearance="primary" multi={true}>
        {[
          <CrossSellingContentWrapper key="1">
            <CollapsibleContainer>
              <CollapsibleContainerHeader>
                <CrossSellingContent>
                  <CrossSellingImageWrapper>
                    <Image
                      alt={''}
                      sm={{
                        src: dxlInformation.imageRef || thumbnailIconSrc || '',
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </CrossSellingImageWrapper>

                  <div>
                    <Heading weight={4} size={1}>
                      {dxlInformation.name}
                    </Heading>
                    <Paragraph size={1} weight={2}>
                      {dxlInformation.description.slice(0, 50)}...
                    </Paragraph>
                  </div>
                </CrossSellingContent>
                <div id="priceText">
                  <Paragraph size={2} weight={2}>
                    Starting at <span>€ {formattedPrice}</span>
                  </Paragraph>
                </div>

                <Button
                  text={buttonText?.label}
                  href={buttonText?.label === 'View details' ? usingOpcoUrl(buttonText?.url) || '' : buttonText?.url}
                  onClick={e => e.stopPropagation()}
                />
              </CollapsibleContainerHeader>

              <CollapsibleContainerBody>
                <hr />
                {dxlInformation.description}

                <LinkWithIcon
                  appearance="primary"
                  icon={{ name: 'pop-out', justify: 'left' }}
                  text={'learn more'}
                  href={buttonText?.label === 'View details' ? usingOpcoUrl(buttonText?.url) || '' : buttonText?.url}
                />
              </CollapsibleContainerBody>
            </CollapsibleContainer>
          </CrossSellingContentWrapper>,
        ]}
      </Accordion>
    </CrossSellingCards>
  );
};

export default CrossSellingAccordionCard;
